export default __webpack_public_path__ + "static/media/ppt.d50533cf.svg";